import axios from "axios";
import { servicePath } from 'constants/defaultValues';
import { getAccessToken } from 'helpers/Firebase';
import moment from 'moment';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
    deleteCategoriesListError, deleteCategoriesListSuccess,

    getCategoriesListError,
    getCategoriesListSuccess
} from './actions';
import {
    CATEGORIES_DELETE_ITEMS, CATEGORIES_GET_LIST, CATEGORIES_INITIALIZE_LIST
} from './actions_def';


const apiUrl = servicePath;

const initializeCategoriesListRequest = async (payload) => {
    // console.log(payload);
    // eslint-disable-next-line no-return-await
    return await new Promise((success) => {
        const instance = axios.create({
            method: 'get',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });
        instance.get('/projects/' + payload.projectId + '/categories/initialize',
            { crossdomain: true })
            .then(response => success(response.data ?
                response.data.map(item => item)
                :
                []));
    })
        .then((response) => response)
        .catch((error) => error);
};

function* initializeCategoriesList({ payload }) {
    // // console.log(payload);;
    if (!payload) {
        yield put(getCategoriesListError({ error: 'prerequisites' }));
    }
    else {
        try {
            const response = yield call(initializeCategoriesListRequest, payload);
            yield put(getCategoriesListSuccess(response));
        } catch (error) {
            yield put(getCategoriesListError(error));
        }
    }
}

const getCategoriesListRequest = async (payload) => {
    // console.log(payload);
    // eslint-disable-next-line no-return-await
    return await new Promise((success) => {
        const instance = axios.create({
            method: 'get',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });
        instance.get('/projects/' + payload.projectId + '/categories/',
            { crossdomain: true })
            .then(response => success(response.data ?
                response.data.map(item => item)
                :
                []));
    })
        .then((response) => response)
        .catch((error) => error);
};

function* getCategoriesList({ payload }) {
    // // console.log(payload);;

    if (!payload) {
        yield put(getCategoriesListError({ error: 'prerequisites' }));
    }
    else {
        try {
            const response = yield call(getCategoriesListRequest, payload);
            yield put(getCategoriesListSuccess(response));
        } catch (error) {
            yield put(getCategoriesListError(error));
        }
    }
}


const deleteCategoriesListRequest = async (items) => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success, fail) => {

        // success(notificationListData.data);
        // var _user = JSON.parse(localStorage.getItem("user"));
        const instance = axios.create({
            method: 'delete',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });

        // console.log('Sending :', {
        //   rfc_title: item.title,
        //   rfc_type: item.type ? item.type : 1,
        //   rfc_summary: item.detail ? item.detail : ' ',
        // })
        let _status = 1;
        switch (items.status) {
            case "PENDING": _status = 1; break;
            default: _status = 1;
        };

        items.map(item => {
            console.log(item)
            instance.delete('/categories/' + item + '/',
                { crossdomain: true })
                .then(response => {
                    if (response.data) {
                        if (response.data.status === "fail") {
                            fail(response.data);
                        }
                        else if (response.data.status === "success" || response.data.status === "ok") {
                            success(response.data);
                        }
                        else {
                            console.log('Inconsistent behaviour', response.data.status)
                        }
                    }
                }).catch((error) => {
                    console.log(error)
                });
        });
    })
        .then((response) => response)
        .catch((error) => error);
};

function* deleteCategoriesList({ payload }) {
    // // console.log(payload);;

    try {
        const response = yield call(deleteCategoriesListRequest, payload);
        yield put(deleteCategoriesListSuccess(response));
    } catch (error) {
        yield put(deleteCategoriesListError(error));
    }
}



export function* watchGetList() {
    yield takeEvery(CATEGORIES_GET_LIST, getCategoriesList);
}

export function* watchInitializeList() {
    yield takeEvery(CATEGORIES_INITIALIZE_LIST, initializeCategoriesList);
}

export function* watchDeleteItems() {
    yield takeEvery(CATEGORIES_DELETE_ITEMS, deleteCategoriesList);
}

export default function* rootSaga() {
    yield all([
        fork(watchGetList),
        fork(watchInitializeList),
        fork(watchDeleteItems),
    ]);
}
